import { Card, CardBody, Col, Row } from 'reactstrap'
import ReactApexChart from 'react-apexcharts'
import { Uses } from '../../../../utils/Constant'
import { usesChart } from '../../../../Data/Widgets/WidgetsChartData'
import CardHeaderCommon from '../../../../CommonElements/CommonCardHeader/CardHeaderCommon'

const UsesWidgets = () => {
  return (
    <Col xl="7" lg="12" className="xl-50 box-col-12">
      <div className="small-chart-widget chart-widgets-small">
        <Card>
          <CardHeaderCommon title={Uses} />
          <CardBody>
            <div className="chart-container">
              <Row>
                <Col xs="12">
                  <ReactApexChart options={usesChart} series={usesChart.series} type="bubble" height={320} />
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>
      </div>
    </Col>
  )
}

export default UsesWidgets